import { render, staticRenderFns } from "./SingleSetting.vue?vue&type=template&id=75202bc2&scoped=true&"
import script from "./SingleSetting.vue?vue&type=script&lang=js&"
export * from "./SingleSetting.vue?vue&type=script&lang=js&"
import style0 from "./SingleSetting.vue?vue&type=style&index=0&id=75202bc2&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75202bc2",
  null
  
)

export default component.exports